export const BM_CREATE = 'bmCreate'
export const BM_EDIT = 'bmEdit'
export const BM_DELETE = 'bmDelete'
export const BM_GET = 'bmGet'
export const BMS_GET = 'bmsGet'
export const BM_SEARCH = 'bmSearch'
export const BM_CASH_FLOW_LIST = 'bmCashFlowList'
export const BM_DAYS_OFF_GET = 'bmDaysOffGet'
export const BM_ACTIVE = 'bmActive'
export const BM_INACTIVE = 'bmInactive'

export const ASSISTANTS_GET = 'assistantsGet'

export const BM_GET_SERVICES = 'bmGetServices'
export const BM_ADD_SERVICE = 'bmAddService'
export const BM_UPDATE_SERVICE = 'bmUpdateService'
export  const BM_DELETE_SERVICE = 'bmDeleteService'
export const BM_ADD_PAYMENT = 'bmAddPayment'
export const BM_ADD_DAY_OFF = 'bmAddDayOff'
export const BM_DELETE_DAY_OFF = 'bmDeleteDayOff'
export const BM_GET_WORK_DAYS = 'bmGetWorkDays'
export const BM_DELETE_WORK_DAY = 'bmDeleteWorkDay'
export const BM_UPDATE_WORK_DAY = 'bmUpdateWorkDay'
export const BM_ADD_WORK_DAY = 'bmAddWorkDay'
export const BM_BALANCE_GET = 'bmBalanceGet'